import {getDomain} from "./getDomain";

function setCookie(key, value, days = 365) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';path=/;domain=.' + getDomain(window.location.hostname) + ';expires=' + expires.toUTCString();
}

export {setCookie}